import React, {Component} from 'react';
import { getAPI, adminloadTP, AuthenticatedUser, stopTimer } from "../../../api";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from '../tournamentPageTemplate'

class TournamentAdminAwards extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.getTdProps = this.getTdProps.bind(this);


        this.state = {
            loading: true,
            open: false,
            user: user,
            tData: {},
            pid: params.pid,
        }

    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            adminloadTP('awards', 'none', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({tData: d2.tournamentPage, tUsers: d2.tUsers, loading: false});                    
                    this.getAwardsAnalysis(this.state.pid)   
                }
            });
        } else this.setState({ loading: false});
    };

    getAwardsAnalysis(pid) {
        getAPI(`/awards/analyze/${pid}`)
        .then(result => {
            const awardsLength = result.data ? result.data.length : 0;
            this.setState({ awardsData: result.data, awardsLength: awardsLength})
        })
    }

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
        }
    }

    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: () => {},
                onMouseOver: (e) => {
                    this.setState({
                        selected: rowInfo.index
                    })
                },
                style: {
                    background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                    //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                }
            }
        } else { return {} }
    }
        
    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, user, awardsData, awardsLength } = this.state;
            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Award List - ${user.displayname}`} title3=""
                bcTitle="Award List" bcParents={[
                    {name: tData.title, url: `/pages/tournament/${tData._id}`},
                    {name: "Administration", url: `/tournament/admin/${tData._id}`}
                ]}
            >              
                <div className="container-fluid">           
                    <div className="row">
                        <div className="col-sm-12">
                            <ReactTable
                                filterable
                                defaultFilterMethod={ (filter, row, column) => {
                                    const id = filter.pivotId || filter.id
                                    return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                }}
                                data={awardsData}
                                columns={[{
                                    Header: 'Event',
                                    accessor: 'event',
                                    maxWidth: 250,                                   
                                },{
                                    Header: 'Place',
                                    accessor: 'index',
                                    maxWidth: 60,                                   

                                },{
                                    Header: 'Team',
                                    accessor: 'displayname',
                                },{
                                    Header: 'SOF',
                                    accessor: 'sof',
                                },{
                                    Header: 'P Rank',
                                    accessor: 'prelimRank',                                        
                                    maxWidth: 70,                                   
                                },{
                                    Header: 'P Wins',
                                    accessor: 'prelimWins',
                                },{
                                    Header: 'P Points',
                                    accessor: 'prelimPoints',
                                },{
                                    Header: 'Max Round',
                                    accessor: 'obtainedRound',
                                },{
                                    Header: 'E Rank',
                                    accessor: 'elimRank',                                        
                                    maxWidth: 70,                                   
                                },{
                                    Header: 'E Wins',
                                    accessor: 'elimWins',
                                },{
                                    Header: 'E Points',
                                    accessor: 'elimPoints',
                                }]}                                        
                                showPagination={true}  
                                pageSize={awardsLength}
                                getTdProps={this.getTdProps}                                                                                                     
                            />
                        </div>
                    </div>  
                </div>
                          
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentAdminAwards;